/**
 * Where an item that hangs directly on a unit sits: before or after the unit's
 * lessons. The teacher picks it in the course builder (metadata.unitPlacement).
 * Without a choice: a unit reading (the resources page) above, everything else
 * below. Same rule as constants/activityAnatomy.js on the server, which also
 * orders "up next" and locking.
 */
export type UnitPlacement = "before" | "after";

type Placeable = {
  type: string;
  placement?: string | null;
  metadata?: Record<string, unknown> | null;
};

export function unitPlacementOf(item: Placeable): UnitPlacement {
  const chosen = item.placement ?? item.metadata?.unitPlacement;
  if (chosen === "before" || chosen === "after") return chosen;
  return item.type === "reading" ? "before" : "after";
}

/** Split a unit's own items into the ones above its lessons and the ones below, keeping their order. */
export function splitUnitItems<T extends Placeable>(items: T[]): { before: T[]; after: T[] } {
  const before: T[] = [];
  const after: T[] = [];
  for (const item of items) (unitPlacementOf(item) === "before" ? before : after).push(item);
  return { before, after };
}
